// extracted by mini-css-extract-plugin
module.exports = {"video_container":"style_video_container__3l0M1","video":"style_video__3m3zO","fallback":"style_fallback__1q4Rs"};